import { GridColumnHeaderParams } from "@mui/x-data-grid-pro";

import { AllWasteTypesFilter } from "../../../../components/TableFilters/AllWasteTypesFilter";
import { NumberFilter } from "../../../../components/TableFilters/NumberFilter";
import { TableHeaderCell } from "../../../../components/TableHeaderCell";
import {
  removeCollectionYardVisitEventsFilter,
  setCollectionYardVisitEventsFilter,
  setCollectionYardVisitEventsOrdering,
} from "../../../../reducers/collectionYardVisitEventsReducer";
import {
  getCollectionYardVisitEventsFilterIsActiveCached,
  getCollectionYardVisitEventsFilterValueCached,
  getCollectionYardVisitEventsOrderingValue,
} from "../../../../selectors/collectionYardVisitEvents";
import { FilterOperator } from "../../../../types/filters";
import { CollectionYardVisitEventsTableColumnType } from "../useGetCollectionYardVisitEventsTableColumns";

const TABLE_NAME = "collectionYardVisitEvents";

interface IHeaderCellProps {
  params: GridColumnHeaderParams;
}

const selectFilters = (type: string) => {
  switch (type) {
    case CollectionYardVisitEventsTableColumnType.wasteTypeId:
      return (
        <AllWasteTypesFilter
          tableName={TABLE_NAME}
          fieldName={type}
          filterSelectorValue={getCollectionYardVisitEventsFilterValueCached}
          filterUpdateAction={setCollectionYardVisitEventsFilter}
          operator={FilterOperator.IsAnyOf}
        />
      );
    case CollectionYardVisitEventsTableColumnType.netto:
    case CollectionYardVisitEventsTableColumnType.rate:
    case CollectionYardVisitEventsTableColumnType.price:
      return (
        <NumberFilter
          tableName={TABLE_NAME}
          fieldName={type}
          filterSelectorValue={getCollectionYardVisitEventsFilterValueCached}
          filterUpdateAction={setCollectionYardVisitEventsFilter}
        />
      );
    default:
      return <div />;
  }
};

export const CollectionYardVisitEventsTableHeaderCell: React.FC<IHeaderCellProps> = ({ params }) => {
  return (
    <TableHeaderCell
      tableName={TABLE_NAME}
      params={params}
      selectorOrdering={getCollectionYardVisitEventsOrderingValue}
      selectorFilterIsActive={getCollectionYardVisitEventsFilterIsActiveCached}
      removeFilterUpdateAction={removeCollectionYardVisitEventsFilter}
      selectFilters={selectFilters}
      orderingUpdateAction={setCollectionYardVisitEventsOrdering}
    />
  );
};
